export default __webpack_public_path__ + "static/media/structure-company.1234175a.png";